import { Col, Row } from 'antd';
import { useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import DeactivatedBanner from './DeactivatedBanner';
import styles from './index.module.less';

import { Logo as HVLogo } from '$HVUI';
import { Button } from '$Molecules/Buttons/Button';
import { multilingualGreeting } from '$Utils';

const prodPrefix = 'https://healthvana-production.s3.amazonaws.com';

export const WelcomeIntl = props => {
    const { changeLanguage } = props;
    const { organization, company, isKiosk } = props.introduction;
    const [isLangSet, setIsLangSet] = useState(false);

    const ahfClass = company?.name === 'ahf' ? styles['ahf'] : '';

    if (organization?.is_inactive) {
        return <DeactivatedBanner companyTitle={company.title} />;
    }

    if (isLangSet) {
        return <Redirect to="/has-account" push />;
    }

    const strings = {
        leadString: {
            kiosk: {
                'en-US': 'Welcome to',
                es: 'Bienvenido a'
            },
            nonKiosk: {
                'en-US': 'Online registration for',
                es: 'Registro en línea para'
            }
        },
        greeting: {
            'en-US': {
                morning: 'Good morning',
                afternoon: 'Good afternoon',
                evening: 'Good evening'
            },
            es: {
                morning: 'Buenos días',
                afternoon: 'Buenas tardes',
                evening: 'Buenas noches'
            }
        }
    };

    const setLanguage = e => {
        const locale = e.currentTarget.value;
        changeLanguage(locale);
        setIsLangSet(true);
    };

    const companyWelcome = function () {
        const leadString = isKiosk
            ? `${strings.leadString.kiosk['en-US']} / ${strings.leadString.kiosk['es']}`
            : `${strings.leadString.nonKiosk['en-US']} / ${strings.leadString.nonKiosk['es']}`;
        if (organization && organization.name) {
            return (
                <span>
                    {leadString} {organization.name}
                </span>
            );
        }
        return (
            <span>
                {leadString} {company.title}
            </span>
        );
    };

    const uploadedLogo =
        !!company.logo &&
        `${company.logo.startsWith('https') ? '' : prodPrefix}${company.logo}`;

    return (
        <div id="dynamic-welcome" className={styles['intl']}>
            <div className={`${styles['logo-container']} ${ahfClass}`}>
                {company?.name === 'ahf' ? (
                    <img
                        src={`${process.env.STATIC}img/_logos/customers/ahf/AHF_logo_large.jpg`}
                        alt="AHF Logo"
                        className={styles['ahf-logo']}
                    />
                ) : (
                    uploadedLogo && (
                        <div className={`${styles['company-logo']}`}>
                            <img
                                src={uploadedLogo}
                                alt={`${company.name} logo`}
                            />
                        </div>
                    )
                )}
                {company?.name === 'ahf' ? (
                    <img
                        src={`${process.env.STATIC}img/_logos/healthvana/powered-by-hv-white-bg-smaller.jpg`}
                        alt="Powered by Healthvana"
                        width={140}
                        data-testid="powered-by-hv-logo"
                        className={styles['powered-by-hv-logo']}
                    />
                ) : (
                    <div className={styles['hv-logo']}>
                        <HVLogo />
                    </div>
                )}
            </div>
            <h1 className={`${styles['big-greeting']} ${ahfClass}`}>
                {multilingualGreeting(strings.greeting['en-US'])} /{' '}
                {multilingualGreeting(strings.greeting.es)}
            </h1>
            <h2 className={styles['company-welcome']}>{companyWelcome()}</h2>
            <Row gutter={[0, 24]} align="middle" justify="center">
                <Col>
                    <p>
                        Choose your language to continue / Elige su idioma para
                        empezar
                    </p>
                </Col>
            </Row>
            <Row gutter={[0, 24]}>
                <Col span={20} offset={2} className={styles['lang-buttons']}>
                    <>
                        <Button
                            element="button"
                            kind="primary"
                            type="button"
                            text="English"
                            value="en-US"
                            onClick={setLanguage}
                        />
                        <Button
                            element="button"
                            kind="primary"
                            type="button"
                            text="Español"
                            value="es"
                            onClick={setLanguage}
                        />
                    </>
                </Col>
            </Row>
        </div>
    );
};

export const mapStateToProps = (state, ownProps) => {
    return Object.assign(
        {},
        {
            introduction: state.introduction
        },
        ownProps
    );
};

export default connect(mapStateToProps, null)(WelcomeIntl);
